/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import { CreatorsAnchors } from '../../../../store/ducks/anchors';
import { getPermissions } from '../../../../services/auth';
import api from '../../../../services/api';
import {
  consultarPerfisErpAtivos,
  adicionar,
  tipoDuplicataKeysToCsv,
  arrayToLojasKeysCsv,
} from '../../../../services/ancorasImportacoesTitulosService';

import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import Loading from '../../../../components/Loading';
import Form, { toTimeSpanPayload } from '../Form';
import useStyles from '../style';

// Padrao Contatos/Lojas: rota /app/ancoras-integracoes-titulos/:ancoraid/cadastrar.
// Recebe ancoraid via route param.
function Register({ ancoraid }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [perfis, setPerfis] = useState([]);
  const [form, setForm] = useState({
    apelido: '',
    importacaoTituloApiErpId: 0,
    clientId: '',
    clientSecret: '',
    tenantSlug: '',
    tipoDuplicataKeys: [],
    horarioGeracaoFull: '',
    horarioGeracaoComplementar: '',
    intervaloMinimoMinutos: '',
    status: 'Ativo',
    enviarBaixaTitulosAntecipados: true,
  });
  const [todasLojas, setTodasLojas] = useState(true);
  const [lojasKeysArr, setLojasKeysArr] = useState([]);

  const carregar = async () => {
    try {
      const [lista, respAncora] = await Promise.all([
        consultarPerfisErpAtivos(),
        api.get(`Ancoras/ConsultarId?id=${ancoraid}`),
      ]);
      setPerfis(lista);
      const nome = respAncora?.data?.resposta?.nomeFantasia;
      if (nome) dispatch(CreatorsAnchors.changeLastAnchor(nome));
    } catch (e) {
      toast.error('Falha ao carregar perfis ERP');
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-integracoes-titulos'));
    const ok = getPermissions({ moduloId: 58872, permissao: 'Cadastrar' });
    if (ok) carregar();
    else history.push('/app');
  }, []);

  const handleFieldChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleToggleTodas = (event) => {
    const checked = event.target.checked;
    setTodasLojas(checked);
    if (checked) setLojasKeysArr([]);
  };

  const validate = () => {
    if (!form.apelido.trim()) return 'Informe o apelido';
    if (!Number(form.importacaoTituloApiErpId)) return 'Selecione o perfil ERP';
    if (!form.clientId.trim()) return 'Informe o Client Id';
    if (!form.clientSecret.trim()) return 'Informe o Client Secret';
    if (!Array.isArray(form.tipoDuplicataKeys) || form.tipoDuplicataKeys.length === 0)
      return 'Selecione ao menos um tipo de duplicata';
    if (!todasLojas && lojasKeysArr.length === 0)
      return "Selecione ao menos uma loja ou marque 'Todas as lojas'";
    return null;
  };

  const handleSubmit = async () => {
    const err = validate();
    if (err) {
      toast.error(err);
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ancoraId: Number(ancoraid),
        apelido: form.apelido.trim(),
        importacaoTituloApiErpId: Number(form.importacaoTituloApiErpId),
        clientId: form.clientId.trim(),
        clientSecret: form.clientSecret,
        tenantSlug: form.tenantSlug ? form.tenantSlug.trim() : null,
        tipoDuplicataKeys: tipoDuplicataKeysToCsv(form.tipoDuplicataKeys),
        lojasKeys: todasLojas ? '' : arrayToLojasKeysCsv(lojasKeysArr),
        horarioGeracaoFull: toTimeSpanPayload(form.horarioGeracaoFull),
        horarioGeracaoComplementar: toTimeSpanPayload(form.horarioGeracaoComplementar),
        intervaloMinimoMinutos:
          form.intervaloMinimoMinutos === '' ? null : Number(form.intervaloMinimoMinutos),
        status: form.status,
        enviarBaixaTitulosAntecipados: !!form.enviarBaixaTitulosAntecipados,
      };
      await adicionar(payload);
      toast.success('Integracao cadastrada com sucesso!');
      history.push(`/app/editar-ancora/${ancoraid}`);
    } catch (e) {
      // erro global ja tratado pelo interceptor
    }
    setSaving(false);
  };

  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Cadastrando integracao ERP da rede: "
        loading={loading || saving}
        back={`/app/editar-ancora/${ancoraid}`}
        submit={handleSubmit}
        submitText="Cadastrar"
        subanchor
      />
      <div className={classes.content}>
        <div className={classes.rootForm} style={{ marginLeft: '5%', width: '90%' }}>
          {loading ? (
            <Loading />
          ) : (
            <div>
              <Form
                mode="register"
                form={form}
                onFieldChange={handleFieldChange}
                perfis={perfis}
                todasLojas={todasLojas}
                onToggleTodasLojas={handleToggleTodas}
                lojasKeysArr={lojasKeysArr}
                onChangeLojas={(e) => setLojasKeysArr(e.target.value)}
                lojasCarregadas={[]}
                carregandoLojas={false}
                onCarregarLojas={() => {}}
              />
              <div className={classes.divButton}>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className={classes.button}
                  disabled={saving}
                >
                  Cadastrar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Register;
